import { constants } from "../constants/redux-constants";

const initialState = {
  selectedTab: {},
  showPopup: false,
  showZoomPopup: false,
  selectedTemplate: {},
  cdssRegenObject: {},
  navigate: "",
  navigateState: null,
  clickedNotificationTaskId: null,
  autoStart: false,
  showSubscriptionPopup: false,
  showExceededSubscriptionPopup: false,
  mobileCollapse: "",
  persistEncID: true,
  isJotPopup: false,
  renderTabValue: {
    renderer: 0,
    data: {},
  },
  currentEvents: [],
  CDSS_exists: false,
  showTaskErrorPopup: {
    isOpen: false,
    message: "",
  },
  micClicked: false,
};

const scribeReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SCRIBE.SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };
    case constants.SCRIBE.SET_SUBSCRIPTION_POPUP:
      return {
        ...state,
        showSubscriptionPopup: action.payload,
      };
    case constants.SCRIBE.SET_EXCEEDED_SUBSCRIPTION_POPUP:
      return {
        ...state,
        showExceededSubscriptionPopup: action.payload,
      };
    case constants.SCRIBE.SHOW_POPUP:
      return {
        ...state,
        showPopup: action.payload,
        navigate: action.route,
        navigateState: action.navigateState,
        clickedNotificationTaskId: action.clickedNotificationTaskId
      };
    case constants.SCRIBE.SHOW_ZOOM_POPUP:
      return {
        ...state,
        showZoomPopup: action.payload,
      };
    case constants.SCRIBE.SELECTED_TEMPLATE:
      return {
        ...state,
        selectedTemplate: action.payload,
      };
    case constants.SCRIBE.AUTO_START:
      return {
        ...state,
        autoStart: action.payload,
      };
    case constants.SCRIBE.CDSS_REGEN_OBJ:
      return {
        ...state,
        cdssRegenObject: action.payload,
      };
    case constants.SCRIBE.SET_MOBILE_COLLAPSE:
      return {
        ...state,
        mobileCollapse: action.payload,
      };
    case constants.SCRIBE.SET_PERSIST_ENC_ID:
      return {
        ...state,
        persistEncID: action.payload,
      };
    case constants.SCRIBE.SHOW_JOT_POPUP:
      return {
        ...state,
        isJotPopup: action.payload,
      };
    case constants.SCRIBE.SET_RENDER_TAB_VALUE:
      return {
        ...state,
        renderTabValue: {
          renderer: state.renderTabValue.renderer,
          data: action.payload,
        },
      };
    case constants.SCRIBE.SET_CURRENT_EVENTS:
      return {
        ...state,
        currentEvents: action.payload,
      };
    case constants.SCRIBE.SET_CDSS_EXISTS:
      return {
        ...state,
        CDSS_exists: action.payload,
      };
    case constants.SCRIBE.SET_CDSS_EXISTS:
      return {
        ...state,
        showTaskErrorPopup: action.payload,
      };
    case constants?.SCRIBE?.SET_MIC_CLICKED:
      return {
        ...state,
        micClicked: action?.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default scribeReducer;
